import script from "./AppBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBar.vue?vue&type=script&setup=true&lang=ts"

import "./AppBar.vue?vue&type=style&index=0&id=953c2c00&lang=css"

const __exports__ = script;

export default __exports__